import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { RefreshIcon } from 'icons/materialIcons';

const TeamRequestsHeader = () => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333' }}>
                Requests
            </Typography>
            <Button variant="contained" startIcon={<RefreshIcon />}>
                Refresh
            </Button>
        </Box>
    );
};

export default TeamRequestsHeader;

